var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C19.5157 3 23.7244 11.2 23.9248 11.6C24.0251 11.8 24.0251 12.2 23.9248 12.4C23.7244 12.8 19.5157 21 12 21C4.92586 21 0.78149 13.7351 0.151837 12.6314C0.112538 12.5625 0.0869305 12.5176 0.0751566 12.5C-0.0250522 12.2 -0.0250522 11.9 0.0751566 11.6C0.275574 11.2 4.48434 3 12 3ZM2.07933 12C3.08142 13.6 6.58873 19 12 19C17.4113 19 20.9186 13.6 21.9207 12C20.9186 10.4 17.4113 5 12 5C6.58873 5 2.98121 10.4 2.07933 12ZM12 8C9.79541 8 7.99165 9.8 7.99165 12C7.99165 14.2 9.79541 16 12 16C14.2046 16 16.0084 14.2 16.0084 12C16.0084 9.8 14.2046 8 12 8ZM9.99582 12C9.99582 13.1 10.8977 14 12 14C13.1023 14 14.0042 13.1 14.0042 12C14.0042 10.9 13.1023 10 12 10C10.8977 10 9.99582 10.9 9.99582 12Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8279_60921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C19.5157 3 23.7244 11.2 23.9248 11.6C24.0251 11.8 24.0251 12.2 23.9248 12.4C23.7244 12.8 19.5157 21 12 21C4.92586 21 0.78149 13.7351 0.151837 12.6314C0.112538 12.5625 0.0869305 12.5176 0.0751566 12.5C-0.0250522 12.2 -0.0250522 11.9 0.0751566 11.6C0.275574 11.2 4.48434 3 12 3ZM2.07933 12C3.08142 13.6 6.58873 19 12 19C17.4113 19 20.9186 13.6 21.9207 12C20.9186 10.4 17.4113 5 12 5C6.58873 5 2.98121 10.4 2.07933 12ZM12 8C9.79541 8 7.99165 9.8 7.99165 12C7.99165 14.2 9.79541 16 12 16C14.2046 16 16.0084 14.2 16.0084 12C16.0084 9.8 14.2046 8 12 8ZM9.99582 12C9.99582 13.1 10.8977 14 12 14C13.1023 14 14.0042 13.1 14.0042 12C14.0042 10.9 13.1023 10 12 10C10.8977 10 9.99582 10.9 9.99582 12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8279_60921)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.33ae362a93e4dbefdb060bed9a35a656.svg";
export { ForwardRef as ReactComponent };